export default [
    {
        path: 'empleados',
        name: 'empresa.empleados',
        redirect: { name: 'empresa.empleados.list' }, // 👈 redirección

        component: () => import('@/views/empresa/empleados/EmpleadosEmpresaLayout.vue'),
        // component: () => import(/* webpackChunkName: "about" */ '@/views/empleado/empleados.vue'),


        children: [
            {
                path: '',
                name: 'empresa.empleados.list',
                component: () => import('@/views/empresa/empleados/EmpresaEmpleadosList.vue'),
                meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
            },
            {
                path: 'asignar',
                name: 'empresa.empleados.asignar',
                component: () => import('@/views/empresa/empleados/EmpleadosSucursalView.vue'),
                meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
            },
            {
                path: 'empleados/registrar',
                name: 'empresa.empleados.registrar',
                component: () => import('@/views/empresa/empleados/EmpleadosRegistrar.vue'),
                meta: { requiresAuth: true, requireArqueoCaja: false, requireCaja: false, requireSucursal: true, requireSucursalSeleccionada: true }
            },

        ],
    },
    {


        path: 'empleados/:id_empleado',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        name: 'empleadoHome',
        redirect: { name: 'empresa.empleado.profile' }, // 👈 redirección


        component: () => import(/* webpackChunkName: "about" */ '@/views/empresa/empleados/EmpleadoEmpresaHome.vue'),
        children: [
            // UserHome will be rendered inside User's <router-view>
            // when /user/:id is matched
            {
                path: 'profile',
                name: 'empresa.empleado.profile',
                component: () => import(/* webpackChunkName: "about" */ '@/views/empresa/empleados/EmpleadoEmpresaProfile.vue'),
            },
            {
                path: 'editar',
                name: 'editarEmpleado',
                component: () => import(/* webpackChunkName: "about" */ '@/views/empresa/empleados/EmpleadoUpdate.vue'),
            },
            {
                path: 'sucursales',
                name: 'empresa.empleado.sucursales',
                component: () => import(/* webpackChunkName: "about" */ '@/views/empresa/empleados/EmpleadoSucursalesList.vue'),
            },
            {
                path: 'info',
                name: 'empleadoSinCliente',
                component: () => import(/* webpackChunkName: "about" */ '@/views/empleado/empleado/empleado.sincliente.vue'),
            },

            {
                path: 'usuario',
                name: 'empleadoUsuario',
                component: () => import(/* webpackChunkName: "about" */ '@/views/empleado/empleado/empleado.usuario.vue'),
            },
            {
                path: 'cuentacorriente/:id_cliente',
                name: 'empleadoCtaCte',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '@/components/shared/clientes/cuentacorriente/ClienteCuentaCorriente.vue'),



            },

            {
                path: 'cuentacorriente/settings/id_cliente:',
                name: 'empleadoCtaCteSettings',
                // route level code-splitting
                // this generates a separate chunk (about.[hash].js) for this route
                // which is lazy-loaded when the route is visited.
                component: () => import(/* webpackChunkName: "about" */ '@/components/shared/clientes/cuentacorriente/ClienteCuentaCorrienteSettings.vue'),
            },

            // ...other sub routes
        ],

    },
]

